import { Component, OnInit } from '@angular/core';
import { TemplateUpdateService } from '../../../services/template-update.service';

@Component({
  selector: 'footer-accessibility',
  templateUrl: './footer-accessibility.component.html',
  styleUrls: ['./footer-accessibility.component.sass']
})
export class FooterAccessibilityComponent implements OnInit {
  infoText = this.templateService.accessibilityInfoText;
  header = this.templateService.accessibilityHeader;
  
  constructor(private templateService: TemplateUpdateService) { }

  ngOnInit(): void {
  }

}
